<template>
    <router-view/>
</template>

<style>
</style>
<script setup>

</script>